/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { MarkerInfo } from './marker-info.class';

export class HarshDrivingEventMarkerInfo extends MarkerInfo {}
